import { useTranslation } from 'src/core/common/hooks/useTranslation';
import {
  NotificationType,
  useNotifications,
} from 'src/core/modules/app/notifications';

import { useTriggerSurvey } from '../../event-tracking/useTriggerSurvey';
import { useMergeEntitySpecificCostCenter } from '../../hooks/useMergeCostCenter';
import { type Setting } from '../../setting';
import { CommonModal } from '../CommonModal';
import {
  CostCenterMergeContent,
  type CostCenterMergeFormValues,
} from '../CostCenterMergeContent';

export const CostCenterMergeModal = ({
  settings,
  isOpen,
  onCancel,
}: {
  settings: Setting[];
  isOpen: boolean;
  onCancel: () => void;
}) => {
  const { t } = useTranslation('global');
  const { pushNotif } = useNotifications();
  const { mutateAsync: mergeEntitySpecificCostCenter } =
    useMergeEntitySpecificCostCenter();

  const triggerSurvey = useTriggerSurvey();

  const handleDetailsComplete = async (values: CostCenterMergeFormValues) => {
    try {
      await mergeEntitySpecificCostCenter({
        name: values.name,
        ownerId: values.ownerId,
        viewerIds: values.viewerIds,
        entitySpecificIds: values.entitySpecificIds,
        crossEntitySettingsIds: values.crossEntitySettingsIds,
        targetCompanyIds: values.targetCompanyIds,
      });

      triggerSurvey();
      pushNotif({
        type: NotificationType.Success,
        message: t(
          'multiEntityHub.costCenters.messages.successMergeCostCenter',
          {
            name: values.name,
          },
        ),
      });
      onCancel();
    } catch {
      pushNotif({
        type: NotificationType.Danger,
        message: t('multiEntityHub.costCenters.messages.errorMergeCostCenter'),
      });
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      title={t('multiEntityHub.costCenters.modal.combination.title')}
      subtitle={t('multiEntityHub.costCenters.modal.combination.modalSubTitle')}
      iconName="arrow-merge"
      onClose={onCancel}
    >
      <CostCenterMergeContent
        onComplete={handleDetailsComplete}
        onCancel={onCancel}
        settings={settings}
      />
    </CommonModal>
  );
};
